import Raven from 'raven-js'

const SENTRY_DSN = `${process.env.SENTRY_DSN}`

function beginErrorTracking() {
  if (process.env.NODE_ENV == 'production') {
    Raven.config(SENTRY_DSN).install()
  }
}

function setUserContext(user) {
  if (process.env.NODE_ENV == 'production') {
    Raven.setUserContext({
      id: user.id,
      email: user.email,
      name: user.name,
      type: user.type
    })
  }
}

const ErrorTracking = {
  begin: () => {
    beginErrorTracking()
  },
  setUser: (user) => {
    setUserContext(user)
  }
}

export default ErrorTracking



// WEBPACK FOOTER //
// ./src/error-tracking.js